var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTooltip = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8 15.06A7.06 7.06 0 1 0 8 .94a7.06 7.06 0 0 0 0 14.12"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#AAB1C7",
  d: "M8 3a3 3 0 0 0-3 2.92h1.71A1.29 1.29 0 1 1 8 7.17h-.86v2.35h1.71v-.81A2.92 2.92 0 0 0 11 5.92 3 3 0 0 0 8 3M7.14 13h1.69v-1.4H7.14z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#AAB1C7",
  fillRule: "evenodd",
  d: "M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8m.94 0C.94 4.1 4.1.94 8 .94A7.07 7.07 0 0 1 15.06 8 7.06 7.06 0 0 1 .94 8",
  clipRule: "evenodd"
})));
export default SvgIconTooltip;